"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class ModelError {
  ErrorCode; //string;
  ErrorMessage; // string;
  ErrorParameter;
  constructor(errorCode, errorParameter, errorMessage) {
    this.ErrorCode = errorCode;
    this.ErrorMessage = errorMessage;
    this.ErrorParameter = errorParameter;
  }
}
exports.default = ModelError;